<template>
  <div :style="new_style_variables" :class="getSlug()">
    <Header
      :logo_link="`/index.html`"
      :home_link="`/index.html`"
      :lang="lang.toUpperCase()"
      :show_home="true"
      :show_languages="true"
      :show_basket="false"
      :basket_number="0"
      :manage_header_no_toggle="true"
      :manage_active="`bookings`"
      :loggedIn="true"
      :key="update_header"
      :logoutText="getrans('Logout')"
    ></Header>
    <div class="page-bg">
      <Basket
        :passedclass="``"
        :positionTop="`24px`"
        :position="`fixed`"
        :showButton="true"
        :lang="`EN`"
        :key="basketKey"
        :hasItems="true"
        :totalfee="100"
        :bookingfee="0"
      ></Basket>

      <div class="results-banner-container">
        
        <Banner active="manage">
          <template v-slot:dashboard>
            {{ getrans("Dashboard") }}
          </template>
          <template v-slot:manage>
            {{ getrans("Manage Bookings") }}
          </template>
          <template v-slot:profile>
            {{ getrans("Update Profile") }}
          </template>
        </Banner>
      </div>

      <div class="page-container">
        <div class="top-section">
          <h2>
            <template v-if="brandSlug === 'SV1'">
              {{ getrans("Dashboard") }}
            </template>
            <template v-else>
              {{ getrans("Your bookings") }}
            </template>
           
          </h2>
          <p>
            <template v-if="brandSlug == 'SV1'">
            {{
              getrans(
                "All bookings land here! View, print or email your tickets, download invoices and amend travel dates."
              )
            }}
            </template>
            <template v-else-if="brandSlug == 'LAX'">
              <p>{{
                getrans(
                  "You will find all your bookings detailed below. Use this overview to manage each booking - it's all in one place!"
                )
              }}</p>
              <div v-if="section == 'bi'">
                <p>Bookings made after Feb 13th 2025 can be retrieved here: <a href="?section=cosmos">Current Bookings</a></p>
              </div>
              <div v-else>
                <p>Bookings made before Feb 13th 2025 can be retrieved here: <a href="?section=bi">Historical Bookings</a></p>
              </div>
            </template>            
            <template v-else-if="brandSlug == 'DRW'">
              <p>{{
                getrans(
                  "You will find all your bookings detailed below. Use this overview to manage each booking - it's all in one place!"
                )
              }}</p>
              <div v-if="section == 'bi'">
                <b>Important Information About Your Booking(s)</b><br /><br />
                <p>
                Your booking(s) were created in our previous system and has been imported into our new platform. Please note the following:<br /><br />
                Changes cannot be made to bookings made before (insert date) in the new system. If you need to update your booking, please cancel it here and make a new reservation using our updated <a target="_blank" href="https://bookings.darwinairport.com.au/">booking platform</a>.<br /><br />
                Your original QR code is still valid. Use the QR code from your confirmation email to enter the parking facility. If you can’t find it, press the assistance button at the car park entrance and our team will help you.<br /><br />
                Refunds for cancelled bookings will be handled manually by the Darwin Airport operations team. After cancelling, please contact us at (08) 8920 1811 or email <a target="_blank" href="mailto:parking@darwinairport.com.au">parking@darwinairport.com.au</a> so we can assist you with the refund process.<br /><br />
                If you need a past receipt or invoice, our support team can retrieve this for you. You will no longer have access to the previous accounts/"Manage My Booking" area, but Darwin Airport support staff can access and provide historical booking documents upon request.<br /><br />
                <i>If you need help at any point, please reach out to us at (08) 8920 1811 or email <a target="_blank" href="mailto:bookings@darwinairport.com.au">bookings@darwinairport.com.au</a>. We’re here to make the transition as smooth as possible.</i><br /><br />
                </p>
                <p>Bookings made after Jan 28th 2026 can be retrieved here: <a href="?section=cosmos">Current Bookings</a></p>
              </div>
              <div v-else>
                <p>Bookings made prior to January 28th, 2026 can be retrieved here: <a href="?section=bi">Historical Bookings</a></p>
              </div>
            </template>            
            <template v-else>
            {{
              getrans(
                "You will find all your bookings detailed below. Use this overview to manage each booking - it's all in one place!"
              )
            }}
            </template>
          </p>
        </div>

        <!-- table -->

        <div class="optional-feilds">
          <div>
            <b>{{ getrans("Optional Fields") }}: </b>
          </div>

          <div
            @click="column_orderid = !column_orderid"
            class="optional-feilds-checkbox"
          >
            <i v-if="column_orderid" class="fas fa-check-square"></i>&nbsp;
            <i v-else class="far fa-square"></i>&nbsp;
            {{ getrans("Booking Reference") }}
          </div>
          <div
            @click="column_airport = !column_airport"
            class="optional-feilds-checkbox"
            v-if="show_venue_checkbox"
          >
            <i v-if="column_airport" class="fas fa-check-square"></i>&nbsp;
            <i v-else class="far fa-square"></i>&nbsp;
            {{ getrans("Airport Name") }}
          </div>
          <div v-if="v5_golive_date != 'THE_FUTURE'">
            If you have booked earlier than {{v5_golive_date}}, please  <a href="/bookings_v5.html" style="margin:0 5px;">click here</a>  to view those bookings
          </div> 
        </div>
        <div class="layout-content">
          <div class="content-section implementation">
            <div class="card" v-if="!OrderHistoryTable_visable">
              <DataTable
                :resizableColumns="true"
                columnResizeMode="fit"
                stripedRows
                :globalFilterFields="[
                  'orderid',
                  'product',
                  'cost',
                  'order_date_unformatted',
                  'date_selected_unformatted',
                  'orderstatus',
                ]"
                responsiveLayout="stack"
                breakpoint="960px"
                :value="tableData"
                :paginator="true"
                :rows="10"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              >
                <Column
                  v-if="brandSlug == 'LAX'"
                  field="laxcarparkref"
                  :header="(brandSlug == 'LAX') ? getrans('LAX Reference') : ''"
                  sortable="false"
                ></Column>                 
                <Column
                  v-if="column_orderid"
                  field="orderid"
                  :header="getrans('Reference')"
                  sortable="true"
                ></Column>
                <Column
                v-if="brandSlug == 'LAX'"
                  field="carpark_name"
                  :header="getrans('Carpark')"
                  sortable="true"
                ></Column>
                <Column
                  field="product"
                  :header="getrans('Product')"
                  sortable="true"
                ></Column>
                <Column
                  v-if="column_airport && brandSlug != 'SZG' && brandSlug != 'DRW'"
                  field="airport"
                  :header="getAirportHeader(brandSlug)"
                  sortable="true"
                ></Column>
                <Column
                  field="cost"
                  :header="getrans('Cost')"
                  sortable="true"
                ></Column>
                <Column
                  field="order_date_unformatted"
                  :header="getrans('Date Booked')"
                  sortable="true"
                >
                  <template #body="slotProps">{{ date_formatter(slotProps.data.order_date) }}</template>
                </Column>
                <Column
                  field="date_selected_unformatted"
                  :header="getrans('Entry Date')"
                  sortable="true"
                >
                  <template #body="slotProps">{{ date_formatter(slotProps.data.date_selected) }}</template>
                </Column>
                <Column
                  v-if="true"
                  field="orderstatus"
                  :header="getrans('Status')"
                  sortable="true"
                  headerStyle="width: 7em; text-align: left"
                >
                  <template #body="slotProps"
                    ><b
                      :class="`status-${slotProps.data.orderstatus.toLowerCase()}`"
                      >{{ getrans(slotProps.data.orderstatus) }}</b
                    ></template
                  >
                </Column>
                <Column header="">
                  <template #body="slotProps">
                    <button
                      class="manage-button"
                      @click="
                        this.gotoPage(
                          `/bookingdetails.html?order_id=${
                            slotProps.data.orderid
                          }&lang=${this.lang.toLowerCase()}`
                        )
                      "
                    >
                      {{ getrans("Manage") }}
                    </button>
                  </template>
                </Column>
              </DataTable>
            </div>

            <!-- order history: -->
            <div class="card" v-if="OrderHistoryTable_visable">
              <div class="history-table-header">
                <button @click="OrderHistoryTable_visable = false">
                  {{ getrans("Back") }}
                </button>
                <h3>
                  {{ getrans("Order history for booking") }}
                  {{ OrderHistoryTable_orderid }}
                </h3>
              </div>

              <DataTable
                :resizableColumns="true"
                columnResizeMode="fit"
                stripedRows
                :globalFilterFields="[
                  'orderid',
                  'product',
                  'cost',
                  'order_date_unformatted',
                  'date_selected_unformatted',
                  'orderstatus',
                ]"
                responsiveLayout="stack"
                breakpoint="960px"
                :value="tableData_history"
                :paginator="true"
                :rows="10"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
              >
                <Column
                  field="orderid"
                  :header="getrans('Reference')"
                  sortable="true"
                ></Column>
                <Column
                  field="product"
                  :header="getrans('Product')"
                  sortable="true"
                ></Column>
                <Column
                  field="airport"
                  :header="getrans('Airport')"
                  sortable="true"
                ></Column>
                <Column
                  field="cost"
                  :header="getrans('Cost')"
                  sortable="true"
                ></Column>
                <Column
                  field="order_date_unformatted"
                  :header="getrans('Date Booked')"
                  sortable="true"
                >
                  <template #body="slotProps">{{ date_formatter(slotProps.data.order_date) }}</template>
                </Column>
                <Column
                  field="date_selected_unformatted"
                  :header="getrans('Entry Date')"
                  sortable="true"
                >
                  <template #body="slotProps">{{ date_formatter(slotProps.data.date_selected) }}</template>
                </Column>
                <Column
                  field="orderstatus"
                  :header="getrans('Status')"
                  sortable="true"
                  headerStyle="width: 7em; text-align: left"
                >
                  <template #body="slotProps">{{
                    getrans(slotProps.data.orderstatus)
                  }}</template>
                </Column>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="brandSlug"
    ></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Basket from "@/components/Basket.vue";
import Banner from "@/components/Banner.vue";
import axios from "axios";
import Swal from "sweetalert2";
import BookingService from "@/service/BookingService";

import { mapActions, mapGetters } from "vuex";
import { slide } from "@/modules/slideToggle";
import { cssData } from "@/modules/cssData";
const genkeys = require("rezauthlib");
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL_ENC, {
  storageType: "sessionStorage",
});
const crypto = require("crypto");	
import md5 from "js-md5";
const localforage = require("localforage");
let store = localforage.createInstance({
  name: "tranlations",
});

import { set_style_vars } from "@/modules/set_style_vars";
import { v5_golive_dates } from "@/modules/v5_golive_dates";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    Basket,
    Banner,
  },
  data() {
    return {
      show_drw_info: false,
      show_venue_checkbox: false,

      column_orderid: true,
      column_airport: true,
      column_customer: true,

      OrderHistoryTable_visable: false,
      OrderHistoryTable_orderid: "",
      lang: "el",
      translations: "",
      brandSlug: "",
      section: "",
      currency: "",
      css_data: undefined,
      tableData: undefined,
      tableData_history: undefined,
      current_id_action: undefined,
      current_orderstatus: "",
      current_orderid: "",
      order_date: "",
      order_date_unformatted: "",
      basketitems: "",
      customernameincart: "",
      date_selected: "",
      date_selected_unformatted: "",
      time_selected: "",
      vehicle_vrn: "",
      customers: "",
      email: "",
      firstname: "",
      orderreference: "",
      product_name: "",
      valid_from: "",
      valid_till: "",
      venuename: "",
      airport: "",
      actions: [],
      brand_product_styles: {},
      header_menu: [],
      footer_links: [],
      footer_columns: "1 Row",
      show_pending_bookings: false,
      update_header: 0,
      carparkref : {"P1 General":"LAXW1","P1 - General EV":"LAXW1V","P1 Premium":"LAXW1P","P1 Premium EV":"LAXW1PV","P1 Valet":"LAXWV1","P2A General":"LAXW2A","P2A EV":"LAXW2AV","P2B General":"LAXW2B","P2B EV":"LAXW2BV","P3 General":"LAXW3","P3 EV":"LAXW3V","P3 Valet":"LAXWV3","P4 General":"LAXW4","P4 EV":"LAXW4V","P4 Valet":"LAXWV4","P5 General":"LAXW5","P5 EV":"LAXW5V","P6 General":"LAXW6","P6 EV":"LAXW6V","P7 General":"LAXW7","P7 Valet":"LAXWV7","Economy General":"LAXWE","Economy EV":"LAXWEV","Budget":"LAXWB","Van Nuys":"LAXVN","P7 EV":"LAXW7V"},
    };
  },
  bookingService: null,
  computed: {
    v5_golive_date() {
      return v5_golive_dates(this.brandSlug);
    },
    new_style_variables() {
      return set_style_vars(this.brand_product_styles);
    },
  },
  methods: {
    ...mapActions(["setSlug", "setBranding", "setCurrency"]),
    ...mapGetters(["getSlug", "getBranding", "getCurrency", "getSiteName"]),
    
    async validateSession() {
      try {
        const sessionValidation = {
          action: 'validate-session',
          sessionId: localStorage.getItem('sessionId'),
          brand_id: this.brandSlug
        };
        
        console.log('Sending validation request:', sessionValidation);
        
        const response = await axios.post('https://devhub.rezcomm.com/hubapmydbauth/mmb/middleware.php', sessionValidation, {
          withCredentials: true
        });
        
        console.log('Middleware response:', response.data);
        
        if (response.data && !response.data.error) {
          return { valid: true, data: response.data };
        } else {
          return { valid: false, error: response.data.error || 'Invalid session' };
        }
      } catch (error) {
        console.error('Session validation failed:', error);
        console.error('Error response:', error.response?.data);
        return { valid: false, error: error.message };
      }
    },
    
    fetchBookingData() {
      let dataSearch = {
        action: 'get-bookings',
        section: this.section,
        sessionId: localStorage.getItem('sessionId'),
        brand_id: this.brandSlug
      };
      
      axios.post('https://devhub.rezcomm.com/hubapmydbauth/mmb/middleware.php', dataSearch, {
        withCredentials: true
      })
        .then((response) => {
          let items = [];
          let check_veunes = [];
          let data = response.data;
          console.log("Booking data response:", data);
          
          // Handle both middleware response format and direct API response format
          let resultData = [];
          if (data && data.success && data.data && data.data.result) {
            resultData = data.data.result;
          } else if (data && data.result) {
            resultData = data.result;
          } else {
            console.error('Invalid booking data response:', data);
            this.tableData = [];
            return;
          }
          
          for (var x = 0; x < resultData.length; x++) {
            try {
              let res = resultData[x];

              if (x == 0) {
                this.getProfileForHeader();
              }

              let item = {};
              item.orderid = res.orderreference;
              item._id = res.orderreference;
              item.vehicle_vrn = res.vehicle_vrn;
              item.email = res.email;
              item.firstname = res.first_name;

              let orderdate = res.orderdate;
              item.order_date_unformatted = res.orderdate;
              if (!orderdate) {
                console.warn('Missing orderdate for order:', res.orderreference);
                item.order_date = 'N/A';
              } else {
                let orderdate_arr = orderdate.split(" ");
                let orderdate_arr_arr = orderdate_arr[0].split("-");
                if (this.usFormatBrands()) {
                  orderdate =
                    orderdate_arr_arr[1] +
                    "/" +
                    orderdate_arr_arr[2] +
                    "/" +
                    orderdate_arr_arr[0] +
                    " " +
                    this.formatTime(orderdate_arr[1]);
                } else {
                  orderdate =
                    orderdate_arr_arr[2] +
                    "/" +
                    orderdate_arr_arr[1] +
                    "/" +
                    orderdate_arr_arr[0] +
                    " " +
                    orderdate_arr[1];
                }
                item.order_date = orderdate;
              }
              
              item.orderstatus = res.orderstatus;
              let order_items = "";
              try {
                if (res.cart && typeof res.cart === 'string') {
                  order_items = JSON.parse(res.cart);
                } else if (res.cart && typeof res.cart === 'object') {
                  order_items = res.cart;
                } else {
                  console.warn('Invalid cart data for order:', res.orderreference);
                  order_items = {};
                }
              } catch (err) {
                console.error('Error parsing cart data for order:', res.orderreference, err);
                order_items = {};
              }
              let totcost = 0;

              let it = order_items;
              if (typeof it === "string") {
                it = JSON.parse(it);
              }
              if (Array.isArray(it) && it.length === 1) {
                it = it[0];
              }
              if (typeof it.carpark_name !== "undefined") {
                item.product = it.carpark_name;
              }

              item.laxcarparkref = '';
              if (typeof it.product_name !== "undefined") {
                item.product = it.product_name;
                item.carpark_name = it.carpark_name;
                if(this.brandSlug.toUpperCase()=='LAX')
                {
                  let pname = it.product_name;
                  console.log('laxcarparkref pname',pname);
                  if(this.carparkref[pname]) 
                  {
                  item.laxcarparkref = this.carparkref[pname]+"-"+res.orderreference_wtpre;
                  console.log('laxcarparkref',item.laxcarparkref);
                  } 
                }                
              }
              if (typeof it.pr_name !== "undefined") {
                item.product = it.pr_name;
              }
              if (typeof it.venue_id !== "undefined") {
                item.venuename = it.venue_id;
              } else {
                item.venuename = 2;
                it.venue_id = 2;
              }
              if (it.venue_id == "5") {
                item.airport = this.getrans("Raleigh Durham Airport");
              }
              if (it.venue_id == "6") {
                item.airport = this.getrans("Raleigh Durham Airport");
              }
              if (it.venue_id == "2") {
                item.airport = this.getrans("Larnaka");
              }
              if (it.venue_id == "3") {
                item.airport = this.getrans("Pafos");
              }
              if (it.venue_id == "1") {
                item.airport = this.getrans("Norwich");
              }
              if (it.venue_id == "10") {
                item.airport = this.getrans("Hamilton International Airport");
              }
              if (it.venue_id == "11") {
                item.airport = this.getrans("Ireland West Airport");
              }
              if (typeof it.venue_select_name === "string") {
                item.airport = this.getrans(it.venue_select_name);
              }
              // Overrides after the select-name
              if (it.venue_id == "26") {
                item.airport = this.getrans("360 Sky Blvd.");
              }
              if (typeof it.valid_from !== "undefined") {
                let valid_from = it.valid_from;
                let valid_till = it.valid_till ? it.valid_till : it.valid_from;
                item.date_selected_unformatted = valid_from;
                let c = valid_from.indexOf("-");
                if (c >= 0) {
                  valid_from = valid_from.replace("-", "/");
                  valid_from = valid_from.replace("-", "/");
                }
                if (c >= 0) {
                  valid_till = valid_till.replace("-", "/");
                  valid_till = valid_till.replace("-", "/");
                }
                console.log("valid_from", valid_from);

                let valid_from_arr = valid_from.split("/");
                let valid_till_arr = valid_till.split("/");
                let start_time = it.start_time;
                let end_time = it.end_time ? it.end_time : it.start_time;
                if (this.usFormatBrands()) {
                  valid_from =
                    valid_from_arr[1] +
                    "/" +
                    valid_from_arr[2] +
                    "/" +
                    valid_from_arr[0] +
                    " " +
                    this.formatTime(start_time);
                } else {
                  valid_from =
                    valid_from_arr[2] +
                    "/" +
                    valid_from_arr[1] +
                    "/" +
                    valid_from_arr[0] +
                    " " +
                    start_time;
                }
                valid_till =
                  valid_till_arr[2] +
                  "/" +
                  valid_till_arr[1] +
                  "/" +
                  valid_till_arr[0] +
                  " " +
                  end_time;
                let date_selected = valid_from;
                item.valid_from = valid_from;
                item.valid_till = valid_till;
                item.date_selected = date_selected;
                item.customers = "";
              } else {
                let date_selected = it.date_selected;
                if (date_selected) {
                  let date_selected_arr = date_selected.split("/");
                  item.valid_from =
                    date_selected_arr[2] +
                    "/" +
                    date_selected_arr[1] +
                    "/" +
                    date_selected_arr[0] +
                    " " +
                    it.time_selected;
                  item.date_selected =
                    date_selected_arr[2] +
                    "/" +
                    date_selected_arr[1] +
                    "/" +
                    date_selected_arr[0] +
                    " " +
                    it.time_selected;
                  item.customers = "Adults: " + it.ADL + ", Children: " + it.CHD;
                } else {
                  item.date_selected = 'N/A';
                  item.date_selected_unformatted = 'N/A';
                  item.customers = "";
                }
              }
              if (!isNaN(parseFloat(res.ordertotal).toFixed(2))) {
                item.cost =
                  this.currency_formatter(parseFloat(res.ordertotal).toFixed(2));
              } else {
                item.cost =
                  this.currency_formatter(parseFloat(res.cart.price).toFixed(2));
              }

              //console.log(item.orderstatus);
              if (
                this.show_pending_bookings === false &&
                item.orderstatus === "Pending"
              ) {
                // dont push
              } else {
                items.push(item);
              }

              if (this.brandSlug == "NWI" || this.brandSlug == "LAX") {
                this.column_airport = false;
              }

              if (this.brandSlug == "LAX") {
                this.column_orderid = false;
              }
            } catch (e) {
              console.log("error", e);
            }
          }
          console.log(items);

          items.map((item) => {
            if (check_veunes.indexOf(item.airport) === -1) {
              check_veunes.push(item.airport);
            }
          });
          if (check_veunes.length > 1) {
            this.show_venue_checkbox = true;
          } else {
            this.show_venue_checkbox = false;
          }

          if (this.brandSlug == "PB1"){
            this.show_venue_checkbox = false;
          }

          this.tableData = items;
        })
        .catch((error) => {
          console.error('Booking data fetch failed:', error);
          // If booking fetch fails due to authentication, redirect to login
          if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            window.location.href = "/index.html";
          }
        });
    },

    getAirportHeader(brandSlug) {
      let header_return = this.getrans("Airport");
      if (brandSlug == "PV1" || brandSlug == "SV1" || brandSlug == "ML1") {
        header_return = this.getrans("Parking Lot");
      }
      if (brandSlug == "PB1") {
        header_return = this.getrans("Venue");
      }
      return header_return;
    },
    usFormatBrands() {
      if (process.env.VUE_APP_US_FORMAT && JSON.parse(process.env.VUE_APP_US_FORMAT).includes(this.getSlug())) {
        return true;
      }
      return false;
    },
    date_formatter(string) {
      if (process.env.VUE_APP_DATE_SEPARATOR_DOT && JSON.parse(process.env.VUE_APP_DATE_SEPARATOR_DOT).includes(this.getSlug())) {
        return string.replaceAll('/', '.');
      }
      return string;
    },
    currency_formatter(money) {
      if (!money) return;
      const arrayString = process.env.VUE_APP_CURRENCY_AFTER_VALUE;
      const array = JSON.parse(arrayString);
      if (array.includes(this.getSlug())) {
        money = money.toString().replace('.',',');
        return money + " " + this.getCurrency();
      }
      return this.getCurrency() + " " + money;
    },
    setStyles(obj) {
      /* eslint-disable */
      obj.forEach((item) => {
        for (const [classname, style] of Object.entries(item)) {
          this.brand_product_styles[classname] = style;
        }
      });
      /* eslint-enable */
    },
    setMenu(data) {
      data.brand_menu_mmb.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
        }
        menu.loggedin = true;
        menu.loggedout = true;
      });
      const top_menu = data.brand_menu_mmb.filter(
        (menu) => menu.position === "T"
      );
      this.createHeaderLinks(top_menu);
      const footer_menu = data.brand_menu_mmb.filter(
        (menu) => menu.position === "B"
      );
      console.log("footer_menu", footer_menu);
      this.createFooterLinks(footer_menu);
    },
    createHeaderLinks(data) {
      const header_menu = [];
      if (data.length > 0) {
        data.forEach((menu) => {
          if (menu.label.toLowerCase() === "basket") {
            this.show_basket = true;
          } else if (menu.label.toLowerCase() !== "home") {
            header_menu.push(menu);
          }
        });
      }
      this.header_menu = header_menu;
    },
    createFooterLinks(data) {
      this.footer_columns = data[0].mcolumn;
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },

    getrans(string) {
      var s = md5(string);
      var ss = this.brandSlug + "-" + this.lang.toUpperCase() + "-" + s;
      //console.log(ss);
      return this.translations[ss] || string;
    },

    getSessionData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    loadTranslations() {
      let vm = this;
      if (vm.getSessionData("language")) {
        vm.lang = vm.getSessionData("language");
      } else {
        vm.setSessionData("language", vm.lang);
      }

      const urlParams = new URLSearchParams(window.location.search);
      let param_lang = urlParams.get("lang");
      if (param_lang) {
        vm.lang = param_lang;
        vm.setSessionData("language", vm.lang);
      }

      console.log(vm.getSessionData("language"));
      console.log("vm.lang");

      console.log(this.lang);

      store.getItem("tranlations").then((params) => {
        if (params !== null) {
          vm.translations = JSON.parse(params);
          console.log("getTranscache");
          console.log(vm.translations);
        } else {
          axios
            .get(
              "https://devhub.rezcomm.com/hubapmydbauth/brandapi/devtrans.php?brandslug=" +
                vm.brandSlug
            )
            .then((response) => {
              console.log("getTranscache index");
              console.log(response);
              vm.translations = JSON.parse(response.request.response);
              store.setItem("tranlations", JSON.stringify(vm.translations));
            });
        }
      });
    },

    showOrderHistoryTable(orderid) {
      console.log(orderid);
      this.tableData_history = [];
      this.OrderHistoryTable_visable = true;
      this.OrderHistoryTable_orderid = orderid;
      this.gethistoricaldata(orderid);
    },

    gotoPage(url) {
      window.location.href = url;
    },
    getLocalData(name) {
      return localStorage.getItem(name);
    },
    setLocalData(name, value) {
      if (value != null) localStorage.setItem(name, value);
      else localStorage.removeItem(name);
    },

    async gethistoricaldata(orderreference) {
      // Validate session before fetching historical data
      const validation = await this.validateSession();
      if (!validation.valid) {
        console.error('Session validation failed for historical data:', validation.error);
        localStorage.removeItem('sessionId');
        sessionStorage.clear();
        window.location.href = "/index.html";
        return;
      }
      
      let dataSearch = {
        action: 'get-historical-bookings',
        orderreference: orderreference,
        sessionId: localStorage.getItem('sessionId'),
        brand_id: this.brandSlug
      };
      
      axios.post('https://devhub.rezcomm.com/hubapmydbauth/mmb/middleware.php', dataSearch, {
        withCredentials: true
      })
        .then((response) => {
          let items = [];
          let data = response.data;
          console.log("data", data);
          for (var x = 0; x < data.result.length; x++) {
            try {
              let res = data.result[x];
              let item = {};
              item.orderid = res.orderreference;

              item._id = res.orderreference;
              item.vehicle_vrn = res.vehicle_vrn;
              item.email = res.email;
              item.firstname = res.first_name;

              let orderdate = res.orderdate;
              item.order_date_unformatted = res.orderdate;
              let orderdate_arr = orderdate.split(" ");
              let orderdate_arr_arr = orderdate_arr[0].split("-");
              if (this.usFormatBrands()) {
                orderdate =
                  orderdate_arr_arr[1] +
                  "/" +
                  orderdate_arr_arr[2] +
                  "/" +
                  orderdate_arr_arr[0] +
                  " " +
                  this.formatTime(orderdate_arr[1]);
              } else {
                orderdate =
                  orderdate_arr_arr[2] +
                  "/" +
                  orderdate_arr_arr[1] +
                  "/" +
                  orderdate_arr_arr[0] +
                  " " +
                  orderdate_arr[1];
              }

              item.order_date = orderdate;
              item.orderstatus = res.orderstatus;

              let order_items = JSON.parse(res.cart);
              let totcost = 0;
              let it = order_items;
              if (typeof it === "string") {
                it = JSON.parse(it);
              }
              if (typeof it === "string") {
                it = JSON.parse(it);
              }
              if (typeof it.carpark_name !== "undefined") {
                item.product = it.carpark_name;
              }
              if (typeof it.product_name !== "undefined") {
                item.product = it.product_name;
              }
              if (typeof it.venue_id !== "undefined") {
                item.venuename = it.venue_id;
              } else {
                item.venuename = 2;
                it.venue_id = 2;
              }
              console.log("it.venue_id", it.venue_id);
              if (it.venue_id == "5") {
                item.airport = this.getrans("Raleigh Durham Airport");
              }
              if (it.venue_id == "6") {
                item.airport = this.getrans("Raleigh Durham Airport");
              }
              if (it.venue_id == "2") {
                item.airport = this.getrans("Larnaka");
              }
              if (it.venue_id == "3") {
                item.airport = this.getrans("Pafos");
              }
              if (it.venue_id == "1") {
                item.airport = this.getrans("Norwich");
              }
              if (it.venue_id == "10") {
                item.airport = this.getrans("Hamilton Airport");
              }	 
              if (typeof it.venue_select_name === "string") {
                item.airport = this.getrans(it.venue_select_name);
              }
              // Overrides after the select-name
              if (it.venue_id == "26") {
                item.airport = this.getrans("360 Sky Blvd.");
              }	 
              if (typeof it.valid_from !== "undefined") {
                let valid_from = it.valid_from;
                let valid_till = it.valid_till;
                item.date_selected_unformatted = valid_from;
                let c = valid_from.indexOf("-");
                if (c >= 0) {
                  valid_from = valid_from.replace("-", "/");
                  valid_from = valid_from.replace("-", "/");
                }
                if (c >= 0) {
                  valid_till = valid_till.replace("-", "/");
                  valid_till = valid_till.replace("-", "/");
                }
                console.log("valid_from", valid_from);
                let valid_from_arr = valid_from.split("/");
                let valid_till_arr = valid_till.split("/");
                let start_time = it.start_time;
                let end_time = it.end_time;

                if (this.usFormatBrands()) {
                  valid_from =
                    valid_from_arr[1] +
                    "/" +
                    valid_from_arr[2] +
                    "/" +
                    valid_from_arr[0] +
                    " " +
                    this.formatTime(start_time);
                } else {
                  valid_from =
                    valid_from_arr[2] +
                    "/" +
                    valid_from_arr[1] +
                    "/" +
                    valid_from_arr[0] +
                    " " +
                    start_time;
                }
                valid_till =
                  valid_till_arr[2] +
                  "/" +
                  valid_till_arr[1] +
                  "/" +
                  valid_till_arr[0] +
                  " " +
                  end_time;
                let date_selected = valid_from;
                item.valid_from = valid_from;
                item.valid_till = valid_till;
                item.date_selected = date_selected;
                item.customers = "";
              } else {
                let date_selected = it.date_selected;
                let date_selected_arr = date_selected.split("/");
                item.valid_from =
                  date_selected_arr[2] +
                  "/" +
                  date_selected_arr[1] +
                  "/" +
                  date_selected_arr[0] +
                  " " +
                  it.time_selected;
                item.date_selected =
                  date_selected_arr[2] +
                  "/" +
                  date_selected_arr[1] +
                  "/" +
                  date_selected_arr[0] +
                  " " +
                  it.time_selected;
                item.customers = "Adults: " + it.ADL + ", Children: " + it.CHD;
              }
              if (!isNaN(parseFloat(res.ordertotal).toFixed(2))) {
                item.cost =
                  this.currency_formatter(parseFloat(res.ordertotal).toFixed(2));
              } else {
                item.cost = 
                  this.currency_formatter(parseFloat(res.cart.price).toFixed(2));
              }

              //console.log(item.orderstatus);
              if (
                this.show_pending_bookings === false &&
                item.orderstatus === "Pending"
              ) {
                // dont push
              } else {
                items.push(item);
              }
            } catch (e) {
              console.log("error", e);
            }
          }
          console.log(items);
          this.tableData_history = items;
        })
        .catch((error) => {
          console.error('Historical data fetch failed:', error);
          if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            window.location.href = "/index.html";
          }
        });
    },

    formatTime(timeString) {
      let [hourString, minute] = timeString.split(":");
      let hour = +hourString % 24;
      return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
    },
    async getProfileForHeader() {
      try {
        const response = await axios.post('https://devhub.rezcomm.com/hubapmydbauth/mmb/middleware.php', {
          action: 'get-profile-data',
          sessionId: localStorage.getItem('sessionId'),
          brand_id: this.brandSlug
        }, {
          withCredentials: true
        });
        
        if (response.data && response.data.result && response.data.result.length > 0) {
          const profileData = response.data.result[0];
          const firstName = decodeURI(profileData.first_name || '');
          const lastName = decodeURI(profileData.last_name || '');
          let initial_1 = Array.from(firstName)[0];
          let initial_2 = Array.from(lastName)[0];
          let initials = initial_1 + initial_2;
          window.sessionStorage.setItem("first_name", firstName);
          window.sessionStorage.setItem("last_name", lastName);
          window.sessionStorage.setItem("initials", initials.toUpperCase());
          this.update_header++;
        }
      } catch (error) {
        console.error('Failed to get profile data for header:', error);
      }
    },
  },
  created() {
    this.bookingService = new BookingService();
  },
  mounted() {
    this.brandSlug = this.getSlug();
    this.currency = this.getCurrency();
    this.lang = "EN";

    console.log('process.env.VUE_APP_US_FORMAT',process.env.VUE_APP_ENABLE_PROFILE);

    if (this.brandSlug === "") {
      this.setSlug().then((response) => {
        this.setBranding(response).then((response) => {
          this.brandSlug = this.getSlug();
          this.branding_data = response;
          this.loadTranslations();
          this.setStyles(this.branding_data.brand_product_styles);
          console.log("bb", this.branding_data);
          console.log("this.branding_data", this.branding_data);
          this.setMenu(this.branding_data);
        });
      });
    } else {
      this.branding_data = this.getBranding();

      if (JSON.stringify(this.branding_data) === JSON.stringify({})) {
        this.setBranding(this.brandSlug).then((response) => {
          this.branding_data = response;
          this.loadTranslations();
          console.log("this.branding_data", this.branding_data);
          this.setStyles(this.branding_data.brand_product_styles);
          this.setMenu(this.branding_data);
        });
      } else {
        console.log("this.branding_data", this.branding_data);
        this.loadTranslations();
        this.setStyles(this.branding_data.brand_product_styles);
        this.setMenu(this.branding_data);
      }
    }

    if (this.brandSlug === "LAX" || this.brandSlug === "DRW") {
      let urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('section')) {
        this.section = urlParams.get('section');
      } else {
        this.section = 'cosmos';
      }
    }

    // Validate session using proper token verification
    const sessionId = localStorage.getItem("sessionId");
    console.log('SessionId found:', sessionId);
    console.log('Brand slug:', this.brandSlug);
    
    if (!sessionId || sessionId === 'null' || sessionId === 'undefined') {
      // MISSING: No sessionId - could be timing issue, show reload message
      console.log('No sessionId found - showing reload message');
      Swal.fire({
        title: this.getrans('Loading Your Orders'),
        text: this.getrans('Please click OK to refresh and load your bookings.'),
        icon: 'info',
        confirmButtonText: this.getrans('OK'),
        allowOutsideClick: false,
        allowEscapeKey: false
      }).then(() => {
        window.location.reload();
      });
    } else {
      // SessionId exists, validate it
      this.validateSession().then((validation) => {
        console.log('Validation result:', validation);
        if (validation.valid) {
          // Session is valid, proceed with booking data fetch
          console.log('Session valid, fetching data');
          this.fetchBookingData();
        } else {
          // EXPIRED: SessionId exists but server rejects it - clear and redirect
          console.error('Session expired:', validation.error);
          localStorage.removeItem('sessionId');
          sessionStorage.clear();
          window.location.href = '/index.html';
        }
      }).catch((error) => {
        // EXPIRED: Validation failed - clear and redirect
        console.error('Session validation error:', error);
        localStorage.removeItem('sessionId');
        sessionStorage.clear();
        window.location.href = '/index.html';
      });
    }
    this.loadTranslations();
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
@import "@/assets/sass/tableOverride.scss";
@import "@/assets/sass/swalOverride.scss";

.swal2-popup.swal2-popup.swal2-popup.swal2-popup {
  max-width: 600px;
  .swal2-content {
    line-height: 1.4;
  }
}
</style>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";

$basketWidth: "420px";
.page-container {
  max-width: 1280px;
  margin: 0 auto 0;
  display: flex;
  flex-direction: column;
  height: auto;
  position: relative;
  .page-time-notice {
    text-align: left;
    display: flex;
    padding: 10px 0;
    p {
      max-width: calc(100% - 120px);
      padding-right: 30px;
      line-height: 1.4;
      font-size: 18px;
      font-family: $font-family-medium;
    }
    .base-timer-wrapper {
      width: 90px;
      height: 90px;
      margin-top: 15px;
    }
    @media screen and (max-width: 500px) {
      flex-direction: column-reverse;
      text-align: center;
      width: 100%;
      p {
        max-width: 100%;
        padding-right: 0px;
        line-height: 1.4;
        font-size: 18px;
      }
      .base-timer-wrapper {
        margin: 10px auto 0;
      }
    }
  }
  .page-left {
    margin: 0 15px;
    margin-bottom: 40px;
    @media screen and (min-width: 958px) {
      width: calc((100% - #{$basketWidth}) - 45px);
      margin-left: 15px;
      margin-right: 30px;
    }
  }
  .page-right {
    width: 0px;
    @media screen and (min-width: 958px) {
      display: block;
      width: #{$basketWidth};
      min-height: 500px;
      margin-right: 8px;
    }
  }
}

.top-section {
  text-align: left;
  margin: 1rem;
  @media screen and (min-width: 958px) {
    margin: 1rem;
  }
  p {
    color: $page-text;
    line-height: 1.5;
    font-family: $font-family-medium;
  }
  h2 {
    color: $page-titles;
    font-family: $font-family-bold;
  }
}

p {
  color: $page-text;
  line-height: 1.4;
  font-size: 18px;
  a {
    color: $page-links;
    &:hover {
      color: darken($page-links, 10%);
    }
  }
}

.history-table-header {
  display: flex;
  padding: 0 1rem 1rem;
  justify-content: space-between;
  align-items: baseline;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    flex-direction: column-reverse;
  }

  button {
    width: auto;
    background-color: $bc-1;
    color: #fff;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
    border-radius: 8px;
    border: none;
    padding: 0.7rem 3rem;
    font-size: 1rem;
    font-weight: 700;
    margin-top: 0rem;
    cursor: pointer;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
}

// banner styles ========================
.page-bg {
  background: #eeeeee;
}
.results-banner-container {
  height: auto;
  background: var(
    --header_banner_background,
    transparent linear-gradient(#0871b9 0%, #034a94 100%) 0% 0% no-repeat
      padding-box
  );
  display: flex;
  align-items: center;
  @media screen and (max-width: 1260px) {
    padding: 0 1rem;
  }
}
.pageheader {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  .pageheader-inner {
    width: 100%;
    max-width: 1260px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .pageheader-title,
    .pageheader-back,
    .pageheader-spacer {
      min-width: 2rem;
      margin: 0;
      * {
        padding: 1.5rem 1rem;
        font-size: 1.3rem;
        margin: 0;
      }
    }
    .pageheader-title {
      font-family: var(--result_title_font_family, inherit);
      //font-size: var(--result_title_font_size, 18pt);
      font-weight: var(--result_title_font_weight, 700);
      color: var(--result_title_font_color, #0a3b74);
    }
    .pageheader-back {
      cursor: pointer;
    }
  }
}
// banner styles ========================

.content-section {
  background: #fff;
  margin: 0 1rem 5rem !important;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%) !important;
  @media screen and (max-width: 960px) {
    box-shadow: none !important;
  }
}

.manage-button {
  padding: 0.4rem 1rem;
  background: var(--mmb_manage_button_background, #0a3b74);
  color: var(--mmb_manage_button_font_color, #fff);
  font-size: var(--mmb_manage_button_font_size, inherit);
  font-family: var(--mmb_manage_button_font_family, inherit);
  font-weight: var(--mmb_manage_button_font_weight, inherit);
  border: var(--mmb_manage_button_border, none);
  border-radius: var(--mmb_manage_button_border_radius, 0.25rem);
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
  border: none;
  font-weight: 700;
  cursor: pointer;
}

.status-amended {
  color: #f0ad4e;
}

.status-booked {
  color: #5cb85c;
}

.status-cancelled {
  color: #d9534f;
}

.status-failed {
  color: #d9534f;
}

.optional-feilds {
  display: flex;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
    gap: 1rem;
  }
  align-items: center;
  padding: 1rem 1rem 2rem;
  gap: 2rem;

  color: var(--result_title_font_color, #0a3b74);
  div {
    display: flex;
    align-items: center;
  }
  i {
    font-size: 1.3rem;
  }
  &-checkbox {
    user-select: none;
    cursor: pointer;
  }
}

.drw-important-info-link {
  text-align: left;
  padding: 1rem 1rem 2rem;
}

.drw-important-info {
  text-align: left;
  padding: 1rem 1rem 2rem;
}
</style>
